import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { PageLayout } from './page/layout'
import { AuthProvider } from './context/auth.context'
import { BreadcrumbProvider } from './context/breadcrumb.context'
import { PassaveProvider } from './context/passave.context'
import { RouteExternal } from './view-external/route'
import { RoleProvider } from './role/role.context'
import { PageProvider } from './context/page.context'

import { TransferProvider } from './shared/transfer/transfer-provider'
import { DisplayUnauth } from './context/display-unauth'
import { UpdateBanner } from './shared/component/update-banner'
import { CredentialExpiryBanner } from './shared/component/credential-expiry-banner'
import { EnvironmentNotice } from './shared/component/environment-notice'
import { AppBanner } from 'edxr-app-banner'
import 'edxr-app-banner/styles.css'

function App() {
  return (
    <div id="app" className="App">
      {/* LOCAL / DEV marker across the top of every page; nothing on production. */}
      <EnvironmentNotice />
      <Router>
        <PageProvider>
          <BreadcrumbProvider>
            <AuthProvider>
              <RoleProvider>
                <PassaveProvider>
                  <TransferProvider>
                    <Switch>
                      <Route path="/external" component={RouteExternal} />
                      <PageLayout />
                    </Switch>
                    {/* Get-the-app banner (shared edxr-app-banner package), on
                        unauthenticated pages only — signed-in users chose the
                        browser. Top placement: the body-padding reservation
                        shrinks the h-100 app shell below it.
                        Runtime overrides: ?eab=top|bottom|off, ?eabhide=1|0 */}
                    <DisplayUnauth>
                      <AppBanner
                        placement="top"
                        icon={
                          <img src={process.env.PUBLIC_URL + '/EDXR-Icon-flat.svg'} alt="" width={48} height={48} />
                        }
                      />
                    </DisplayUnauth>

                    {/* Deploys replace the bundle under any tab that is already
                        open. This notices and offers a reload — signed in or
                        not, since either can be left open across a deploy. */}
                    <UpdateBanner />

                    {/* Warns a sys-provider admin when a provider credential is
                        within 30 days of expiring (or already past it) — the
                        SSO-hardening equivalent of UpdateBanner, same bottom-left
                        family, offsetting itself above UpdateBanner when both
                        would otherwise show at once. */}
                    <CredentialExpiryBanner />
                  </TransferProvider>
                </PassaveProvider>
              </RoleProvider>
            </AuthProvider>
          </BreadcrumbProvider>
        </PageProvider>
      </Router>
    </div>
  )
}

export default App
